export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-keep-it-simple-0487133a0c7a4be911987ed47be9d4cf.jpg";